import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { setSharableProductImage } from '../../actions/sharing';
import { getCurrentPatternThumbnailUri } from '../../reducers/currentPattern';
import { getCurrentPatternDesigner } from '../../reducers/designer';
import { getMessage } from '../../reducers/i18n';
import { getSewpatGalleryOverlay } from '../../reducers/sewpats';
import {
    getPreviewRepeats,
    getShowRecoloringLoader,
} from '../../reducers/ui.recoloring';
import { getPattern } from '../../reducers/patterns';


class ProductPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            overlay: 0,
        };
    }


    componentDidMount() {
        this.overlay = new Image();
        this.overlay.crossOrigin = 'Anonymous';
        this.overlay.onload = () => {
            this.setState(Object.assign({}, this.state, { overlay: 1 }));
        };
        this.overlay.src =
            `https://d1hifgxwzqc0jz.cloudfront.net/schnittmuster/${
                this.props.sewpatId}/${this.props.figurine.src}`;
        this.updatePreview();
    }

    componentDidUpdate() {
        this.updatePreview();
    }

    componentWillUnMount() {
        if (!this.overlay) {
            return;
        }
        this.overlay.onload = () => {};
    }

    updatePreview() {
        if (this.state.overlay === 0) {
            return;
        }

        this.canvas = document.createElement('canvas');
        this.canvas.width = this.props.figurine.width;
        this.canvas.height = this.props.figurine.height;
        const ctx = this.canvas.getContext('2d');

        this.pattern = new Image();
        this.pattern.crossOrigin = 'anonymous';
        this.pattern.onload = () => {
            const tempCanvas = document.createElement('canvas');
            const tCtx = tempCanvas.getContext('2d');
            tempCanvas.width = this.props.figurine.width / this.props.col;
            tempCanvas.height =
                this.pattern.height / (
                this.pattern.width / tempCanvas.width
                );
            tCtx.drawImage(
                this.pattern,
                0,
                0,
                this.pattern.width,
                this.pattern.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height,
            );
            ctx.fillStyle = ctx.createPattern(tempCanvas, 'repeat');
            ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
            ctx.drawImage(
                this.overlay,
                0,
                0,
                this.overlay.width,
                this.overlay.height,
                0,
                0,
                this.canvas.width,
                this.canvas.height,
            );
            const imageSrc = this.canvas.toDataURL();
            this.preview.src = imageSrc;
            this.setShareImage(imageSrc);
        };
        this.pattern.src = `${this.props.imgUri}?_`;
    }

    setShareImage = img => setSharableProductImage(img);

    StyledWrapper = styled.figure`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin: 0.1em;
    `;

    CanvasWrapper = styled.div`
        max-width: ${`${Math.min(300, this.props.figurine.width)}px`};
        max-height: ${`${Math.min(450, this.props.figurine.height)}px`};
        width: 45vw;
        height: auto;

        & .stolo-responsive-img {
          width: 100%;
          height: auto;
        }
    `;

    render() {
        return (
            <this.StyledWrapper
                itemProp='image' itemScope
                itemType='http://schema.org/ImageObject'
            >
                <this.CanvasWrapper>
                    <img
                        className='stolo-responsive-img'
                        ref={img => this.preview = img}
                        alt='Druckvorschau lädt ...'
                        data-pin-description={`${this.props.pattern.title}: ${
                        this.props.shareMessage}`}
                        itemProp='contentUrl'
                        title={<FormattedMessage
                            id='DISCLAIMER_PRODUCT_PREVIEW'
                            defaultMessage='Beispielhafte Vorschau. Farben und Anordnung des Musters können abweichen.'
                        />}
                    />
                </this.CanvasWrapper>
            </this.StyledWrapper>
        );
    }
}


const mapDispatchToProps = dispatch => (
    {
        setSharableProductImage: img => dispatch(setSharableProductImage(img)),
    }
);

const makeMapStateToProps = initialState => {
    const { patternid, sewpatId } = initialState.location.payload;
    const pattern = getPattern(initialState, patternid);
    const overlay = getSewpatGalleryOverlay(initialState);
    const shareMessage = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_DEFAULT_PREFIX',
    );
    const mapStateToProps = state => {
        const { col, rows } = getPreviewRepeats(state);
        const imgUri = getCurrentPatternThumbnailUri(state, patternid);
        return {
            pattern,
            imgUri,
            col,
            rows,
            sewpatId,
            figurine: overlay,
            shareMessage,
        };
    };
    return mapStateToProps;
};

export default connect(
    makeMapStateToProps,
    mapDispatchToProps,
)(ProductPreview);



// WEBPACK FOOTER //
// ./src/components/addtocart/ProductPreview.js